import { render, staticRenderFns } from "./ExamineRemarkDialog.vue?vue&type=template&id=e3816950&scoped=true"
import script from "./ExamineRemarkDialog.vue?vue&type=script&lang=js"
export * from "./ExamineRemarkDialog.vue?vue&type=script&lang=js"
import style0 from "./ExamineRemarkDialog.vue?vue&type=style&index=0&id=e3816950&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3816950",
  null
  
)

export default component.exports